/* gorilla-pfl-ambassador.js — scroll-synced dot indicators for the
   ambassador carousel (mobile). Mirrors the PDP social-proof behavior;
   dots are hidden on desktop via CSS. */
(function () {
  'use strict';

  function init(root) {
    var track = root.querySelector('.gorilla-pfl-amb__cards');
    var dotsWrap = root.querySelector('.gorilla-pfl-amb__dots');
    if (!track || !dotsWrap) return;

    var dots = dotsWrap.querySelectorAll('.gorilla-pfl-amb__dot');
    var cards = track.querySelectorAll('.gorilla-pfl-amb__card');
    if (!dots.length || !cards.length) return;

    function updateDots() {
      var gap = 20;
      var cardWidth = cards[0].offsetWidth + gap;
      var idx = Math.round(track.scrollLeft / cardWidth);
      idx = Math.max(0, Math.min(idx, dots.length - 1));
      for (var i = 0; i < dots.length; i++) {
        dots[i].classList.toggle('gorilla-pfl-amb__dot--active', i === idx);
      }
    }

    track.addEventListener('scroll', updateDots, { passive: true });
  }

  document.addEventListener('DOMContentLoaded', function () {
    var roots = document.querySelectorAll('.gorilla-pfl-amb');
    Array.prototype.forEach.call(roots, init);
  });
})();
